module.exports = __webpack_public_path__ + "img/sepire-logo.68fb5675.svg";